// extracted by mini-css-extract-plugin
module.exports = {"forbiddenIconCol":"ForbiddenDisplay_forbiddenIconCol__hRBKD"};